/**
 * @generated SignedSource<<11de19ca6e0a266c308158f10c530979>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CompetitionTopicCreatePageQuery$variables = {
  slug: string;
};
export type CompetitionTopicCreatePageQuery$data = {
  readonly competitionBySlug: {
    readonly forum: {
      readonly id: string;
    };
    readonly id: string;
    readonly slug: string;
  } | null | undefined;
};
export type CompetitionTopicCreatePageQuery = {
  response: CompetitionTopicCreatePageQuery$data;
  variables: CompetitionTopicCreatePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "Competition",
    "kind": "LinkedField",
    "name": "competitionBySlug",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Forum",
        "kind": "LinkedField",
        "name": "forum",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionTopicCreatePageQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompetitionTopicCreatePageQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b590d742d4ec48ad599015ac96e8f9e9",
    "id": null,
    "metadata": {},
    "name": "CompetitionTopicCreatePageQuery",
    "operationKind": "query",
    "text": "query CompetitionTopicCreatePageQuery(\n  $slug: String!\n) {\n  competitionBySlug(slug: $slug) {\n    id\n    forum {\n      id\n    }\n    slug\n  }\n}\n"
  }
};
})();

(node as any).hash = "b516390744caef3783e0544d7e33708c";

export default node;
